export default "__VITE_ASSET__2XrhBkw5__"